import CellType from '@/common/enums/cell-type.enum';
import formatNumber from '@/utils/NumberFormatter';

const formatCellByType = (value, cellType) => {
  switch (cellType) {
    case CellType.CURRENCY:
      return formatNumber(value, '$0.0a');
    case CellType.PERCENTAGE:
      return formatNumber(value, '0.00%');
    default:
      return value;
  }
};

const CellTypeFormatterUtils = {
  formatCellByType,
};

export default CellTypeFormatterUtils;
